import React, {
  createContext,
  FC,
  ReactNode,
  useContext,
  useMemo,
  useState,
} from 'react';
import { AssignmentModel } from 'api/model';

interface ActiveAssignmentContextValue {
  assignmentIds: number[];
  activeAssignment?: number;
  setActiveAssignment: (id?: number) => void;
}

const ActiveAssignmentContext = createContext<
  ActiveAssignmentContextValue | undefined
>(undefined);

interface ActiveAssignmentProviderProps {
  availableAssignments: AssignmentModel[];
  children: ReactNode;
}

export const ActiveAssignmentProvider: FC<ActiveAssignmentProviderProps> = ({
  availableAssignments,
  children,
}) => {
  const [activeAssignment, setActiveAssignment] = useState<number | undefined>(
    undefined
  );

  const contextValue = useMemo(
    () => ({
      assignmentIds: availableAssignments.map((x) => x.assignmentID),
      activeAssignment,
      setActiveAssignment,
    }),
    [availableAssignments, activeAssignment, setActiveAssignment]
  );

  return (
    <ActiveAssignmentContext.Provider value={contextValue}>
      {children}
    </ActiveAssignmentContext.Provider>
  );
};

export const useActiveAssignment = (): ActiveAssignmentContextValue | null => {
  const context = useContext(ActiveAssignmentContext);
  if (!context) {
    // throw new Error(
    //   'useActiveAssignment must be used within an ActiveAssignmentProvider'
    // );
    return null;
  }
  return context;
};
